import { useEffect, useState } from "react";
import { Office } from "@/api/offices";
import { api } from "@/api";
import { Link } from "react-router-dom";
import { S3_URL } from "@/api/s3";
import {
  FaMapMarkerAlt,
  FaExpandArrowsAlt,
  FaParking,
  FaCoffee,
} from "react-icons/fa";
import { FaCartPlus, FaUsers, FaWifi } from "react-icons/fa6";
import { Button } from "@heroui/react";

export function PublicOfficesPage() {
  const [publicOffices, setPublicOffices] = useState<Office[]>([]);

  useEffect(() => {
    api.offices.listPublic().then((res) => {
      setPublicOffices(res.data);
    });
  }, []);

  return (
    <>
      <div className="flex flex-row flex-wrap gap-4 w-full">
        <div className="flex-grow bg-white dark:bg-zinc-900 rounded-xl border-2 border-foreground-200 dark:border-foreground-100 p-4">
          <div className="flex flex-row justify-between w-full items-center mb-4">
            <div className="flex flex-row gap-4 items-center">
              <span className="font-medium">Офисы на маркетплейсе</span>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {publicOffices.map((office) => (
              <Link
                to={`/dashboard/offices/${office.id}/edit`}
                className="flex flex-col rounded-xl"
                key={office.id}
              >
                <img
                  alt={office.display_name}
                  className="w-full min-h-48 h-48 object-cover rounded-t-xl"
                  src={`${S3_URL}/${office.main_photo}`}
                />
                <div className="border-2 border-t-0 rounded-b-xl p-4 flex flex-col gap-2 h-full">
                  <h2 className="font-semibold">{office.display_name}</h2>
                  <h3 className="flex flex-row items-center gap-2 text-sm font-medium text-foreground text-opacity-70">
                    <FaMapMarkerAlt />
                    {office.location_display_name}
                  </h3>
                  <div className="flex flex-row gap-2 text-sm">
                    <h4 className="flex flex-row items-center gap-2">
                      <FaExpandArrowsAlt />
                      {office.area} м²
                    </h4>
                    <h4 className="flex flex-row items-center gap-2">
                      <FaUsers />
                      До {office.workplace_count} чел.
                    </h4>
                  </div>
                  <div className="flex flex-row gap-2 text-sm">
                    <FaWifi />
                    <FaParking />
                    <FaCoffee />
                  </div>
                  <div className="flex flex-row items-center justify-between w-full mt-auto">
                    <h5 className="text-sm font-bold">
                      ₽{office.price.toLocaleString("ru-RU")}
                      <h5 className="text-sm font-medium text-foreground text-opacity-70">
                        /мес.
                      </h5>
                    </h5>
                    <div className="flex flex-row gap-2">
                      <Button
                        color="success"
                        variant="flat"
                        size="sm"
                        startContent={<FaCartPlus />}
                        isIconOnly
                      />
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
